import { VIEWS_MAP } from '../../router/constants';

export const FEATURE_FLAG_ID = 'Ach Out Transfer';
export const VALID_FLAG_VALUE = 'show';

export const STEPS_MAP = {
  ZERO_STATE: 0,
  ENROLLMENT: 1,
  TRANSFER_AMOUNT: 2,
  REVIEW_CONFIRM: 3,
  TRANSFER_DONE: 4,
  ENROLL_ERROR: 5,
  MFA: 6,
};

export const WIZARD_MODE_STEPS = [STEPS_MAP.TRANSFER_AMOUNT, STEPS_MAP.REVIEW_CONFIRM, STEPS_MAP.TRANSFER_DONE];

export const PREV_STEP_MAP = [0, 0, 1, 2, 3, 4];

export const FORM_INPUTS = [
  {
    TITLE: 'Payee or Business Name',
    TYPE: 'payeeName',
    VALIDATION: /^.{2,}$/,
    ERROR: 'WELCOME_PAGE_INPUT_EMAIL_ERROR',
    AUTOCOMPLETE: 'payee',
  },
  {
    TITLE: 'Routing Number',
    TYPE: 'routingNumber',
    VALIDATION: /^.{2,}$/,
    ERROR: 'WELCOME_PAGE_INPUT_EMAIL_ERROR',
    AUTOCOMPLETE: 'rout_num',
  },
  {
    TITLE: 'Account Number',
    TYPE: 'accountNumber',
    VALIDATION: /^.{2,}$/,
    ERROR: 'WELCOME_PAGE_INPUT_EMAIL_ERROR',
    AUTOCOMPLETE: 'acc_num',
  },
];

export const FORM_STEPS_INPUTS = {
  CONFIRM_ACC_NUM: [
    {
      TITLE: 'ACCOUNT_NUMBER_INPUT_TITLE',
      TYPE: 'accountNumber',
      VALIDATION: '^{ACCOUNT_NUMBER}$',
      REPLACE: /\D/g,
      ERROR: 'ACCOUNT_NUMBER_INPUT_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 17,
    },
  ],
  DETAILS: [
    {
      TITLE: 'ACH_OUT_FORM.DETAILS.INPUT_1_TITLE',
      TYPE: 'businessName',
      VALIDATION: /^.{2,}$/,
      // REPLACE: /[^a-zA-z\s]/g,
      ERROR: 'ACH_OUT_FORM.DETAILS.INPUT_1_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 22,
      VALUE: '',
      DISABLED: false,
    },
    {
      TITLE: 'ACH_OUT_FORM.DETAILS.INPUT_2_TITLE',
      TYPE: 'accountNumber',
      VALIDATION: /^\d{6,17}$/,
      REPLACE: /\D/g,
      ERROR: 'ACH_OUT_FORM.DETAILS.INPUT_2_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 17,
      VALUE: '',
      DISABLED: false,
    },
    {
      TITLE: 'ACH_OUT_FORM.DETAILS.INPUT_3_TITLE',
      TYPE: 'routingNumber',
      VALIDATION: /^\d{9,9}$/,
      REPLACE: /\D/g,
      ERROR: 'ACH_OUT_FORM.DETAILS.INPUT_3_ERROR',
      AUTOCOMPLETE: 'none',
      MAX_LENGTH: 9,
      VALUE: '',
      DISABLED: false,
    },
  ],
};

export const CONTAINER_HEIGHTS = {
  SMALL: 'h-[548px]',
  MEDIUM: 'h-[618px]',
  LARGE: 'h-full',
};

export const LIMITS_INITIAL_STATE = { balance: 0, monthlyLimit: 0, dailyLimit: 0 };

export const INITIAL_ACH_OUT_RESPONSE = {
  processTime: '',
  status: '',
  transactionId: '',
  mfaActionData: {},
};

export const FORM_INITIAL_STATE = {
  accountNumber: '',
  businessName: '',
  routingNumber: '',
  transferAmount: '',
  feeData: {
    achTransferType: '',
    arrivalDate: '',
    arrivalDateShort: '',
    fee: 0,
  },
};

export const LIMITS_TYPES = {
  BALANCE: 'balance',
  DAILY: 'dailyLimit',
  MONTHLY: 'monthlyLimit',
};

export const EDIT_MODE_TYPES = {
  AMOUNT: 'AMOUNT',
  DETAILS: 'DETAILS',
};

export interface IFormData {
  accountNumber: string;
  businessName: string;
  routingNumber: string;
  transferAmount: string;
  feeData: { achTransferType: string; arrivalDate: string; arrivalDateShort?: string; fee: number };
}

export interface IAchOutFees {
  expirationDate: Date;
  feeDescription: string;
  fees: [{ achTransferType: string; arrivalDate: string; arrivalDateShort: string; fee: number }];
  updatedAt?: Date;
}

export const TRANSFER_DONE_DATA = {
  CONTAINER: {
    CSS: 'w-[464px] h-fit relative flex flex-col h-fit rounded-[8px] bg-bw02',
  },
  ICON: {
    SRC: '',
    CSS: 'w-[94px] h-[94px]',
  },
  HEADING: {
    TEXT: 'ACH_OUT_DONE.TITLE',
    CSS: 'font-metricRMedium text-[18px] text-bw08 mt-[10px] mb-[5px] text-center',
  },
  DISCLAIMER: {
    TEXT: 'ACH_OUT_DONE.DISCLAIMER',
    CSS: 'font-metricR text-bw07 text-md mb-[16px] text-center',
  },
  BUTTONS_CONTAINER: {
    CSS: 'flex justify-between mt-[16px]',
  },
  MAKE_ANOTHER_CTA: {
    TEXT: 'ACH_OUT_DONE.MAKE_ANOTHER_CTA',
    CSS: 'w-[226px] h-[54px] text-center rounded border-action03 border-[1px] flex justify-center items-center mr-[12px] text-action03 font-metricRMedium text-md',
  },
  DONE_CTA: {
    TEXT: 'ACH_OUT_DONE.DONE_CTA',
    CSS: 'w-[226px] h-[54px] text-center rounded flex justify-center items-center mr-[12px] bg-action03 hover:bg-action04 active:bg-action04 text-bw00 font-metricRMedium text-md',
  },
  TRANSFER_DETAILS: {
    STYLES: {
      UPPER_ROW: 'py-[18px] text-center border-b-[1px] border-bw03 rounded-t-[8px] bg-bw00',
      ROW: 'h-[48px] flex justify-between py-[12px] px-[16px] border-b-[1px] border-bw03 bg-bw00',
      LOWER_ROW: 'flex items-center justify-center py-[11px] bg-bw01 rounded-b-[8px] bg-bw01',
      PLACE_HOLDER: 'font-metricR text-bw05 text-base',
      VALUE_WRAPPER: 'flex items-center',
      ROW_TITLE: 'text-md text-bw07 font-metricR',
      ROW_VALUE: 'text-md text-bw08 font-metricR',
    },
    AMOUNT: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.AMOUNT',
      CSS: 'text-[26px] text-action03 font-metricRMedium text-center',
    },
    RECIPIENT: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.TO',
      CSS: 'text-base text-bw08 font-metricR',
    },
    ACC_NUM: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.ACC_NUM',
      CSS: 'text-base text-bw07 font-metricR',
    },
    ROUT_NUM: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.ROUT_NUM',
      CSS: 'text-base text-bw07 font-metricR',
    },
    EST_ARR: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.EST_ARR',
      CSS: 'text-base text-bw08 font-metricR',
    },
    PROC_DATE: {
      PLACE_HOLDER: 'ACH_OUT_DONE.TRANSFER_DETAILS.PROC_DATE',
      CSS: 'font-metricR text-bw07 text-sm',
    },
  },
};

export const FLOW_INDEX_DATA = {
  PAGE_HEADER: 'ACH_OUT_PAGE_HEADER',
  CSS: {
    LAYOUT:
      'bg-bw02 flex flex-col mx-[24px] tab-landscape:pl-[88px] pc-sm:pl-[296px] pt-[3.688rem] pb-20 pr-[34px] fadeIn tab-landscape:w-[calc(100%-24px)] pc-sm:w-[calc(100%-24px)]',
    BACK_BUTTON_STYLE: 'flex items-center justify-center w-[2rem]',
    NAV_BAR_STYLE: 'flex items-start mb-6 mt-[18px]',
    HEADER_STYLE: 'text-bw08 font-metricR text-xl',
    MAIN_CONTENT_WIDTH: 'w-full flex justify-center',
    MAIN_CONTENT_MFA: 'w-full h-full',
    APP_LAYOUT_WIZARD: 'absolute inset-0 z-[50] bg-bw00 h-screen w-screen flex flex-col fadeIn overflow-hidden',
  },
};
export const STEP_SWITCH_DATA = {
  ZERO_STATE_CONTAINER:
    'flex flex-col items-center justify-center w-full h-[548px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
  SPINNER_COLOR: '#0E5CF4',
  SPINNER_SIZE: '2rem',
};
export const CONFIRM_DATA = {
  TEXTS: {
    TITLE: 'ACH_OUT_CONFIRM.TITLE',
    TEXT: 'ACH_OUT_CONFIRM.TEXT',
    FORM_SUBMIT: 'ACH_OUT_CONFIRM.FORM_SUBMIT',
  },
  CSS: {
    CONTAINER: 'flex flex-col w-[456px] h-[594px] rounded-[8px] py-[40px] px-[40px]',
    TITLE: 'font-metricR text-[24px] text-bw08 mb-[16px]',
    TEXT: 'font-metricR text-[16px] text-bw07 mb-[40px]',
    FORM: 'flex flex-col h-full',
    FORM_SUBMIT: 'w-[240px] mx-auto',
  },
};
export const ENROLL_DATA = {
  TEXTS: {
    TITLE: 'ACH_OUT_ENROLL.TITLE',
    TEXT: 'ACH_OUT_ENROLL.TEXT',
    SUBMIT_CTA: 'ACH_OUT_ENROLL.SUBMIT_CTA',
  },
  CSS: {
    CONTAINER: 'flex flex-col w-[456px] h-[548px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
    ICON: 'w-[94px] mb-[20px]',
    TITLE: 'font-metricR text-[24px] text-bw08 mb-[16px]',
    TEXT: 'font-metricR text-[16px] text-bw07',
    SUBMIT_CTA:
      'font-metricRSemibold text-bw00 hover:bg-action04 bg-action03 py-[13px] text-base rounded-[4px] w-[240px] mt-auto',
  },
};
export const DETAILS_DATA = {
  TEXTS: {
    TITLE_EDIT_ON: 'ACH_OUT_DETAILS.TITLE_EDIT_ON',
    TITLE_EDIT_OFF: 'ACH_OUT_DETAILS.TITLE_EDIT_OFF',
    SUBMIT_CTA_EDIT_ON: 'ACH_OUT_DETAILS.SUBMIT_CTA_EDIT_ON',
    SUBMIT_CTA_EDIT_OFF: 'ACH_OUT_DETAILS.SUBMIT_CTA_EDIT_OFF',
    CANCEL_CTA: 'ACH_OUT_DETAILS.CANCEL_CTA',
  },
  CSS: {
    CONTAINER: 'flex flex-col w-[456px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
    EDIT_ON: 'h-[672px] animate-fadeIn',
    EDIT_OFF: 'h-[594px]',
    TITLE: 'font-metricR text-[24px] text-bw08 mb-[16px]',
    FORM: 'flex flex-col h-full',
    SUBMIT_CTA: 'w-[240px] mx-auto',
    SUBMIT_CTA_EDIT: 'mb-[16px]',
    CANCEL_CTA: 'font-metricR text-[14px] text-bw06',
  },
};

// TODO REEM
// const AMOUNT_DATA = {};
export const REVIEW_DATA = {
  STYLES: {
    CONTAINER: 'relative flex grow flex-col w-[464px] h-fit rounded-[8px] bg-bw00 py-[16px] px-[16px] pt-[64px]',
    EDIT: 'font-metricR text-[16px] text-bw08 underline',
    WRAPPER_CONTAINER: 'rounded-[8px] p-[16px] border-[0.8px] border-bw03 my-[16px]',
    MAIN_HEAD: 'font-metricR text-[28px] text-bw08 text-center',
    REVIEW_ITEM_CONTAINER: 'flex justify-between my-[10px] last:my-0',
    REVIEW_ITEM_CONTAINER_BORDER: 'border-b-[1px] border-bw03',
    REVIEW_ITEM_HEADER: 'font-metricR text-bw07 text-[16px] flex items-center',
    UNDERLINE: 'w-full h-[0.8px] bg-bw03',
    REVIEW_ITEM_MAIN_HEADER: 'font-metricR text-bw08 text-[18px] font-bold',
    TRANSFER_ITEMS_CONTAINER: 'flex flex-col pt-[12px]',
    TRANSFER_ITEMS_HEAD: 'font-metricR text-[16px] text-bw08 mb-[12px] px-[16px]',
    REVIEW_AMOUNT: 'text-[22px] text-action03 font-metricRMedium',
    REVIEW_PAYEE: 'text-[16px] text-bw08 font-metricR',
    REVIEW_ACCOUNT_NUMBER: 'text-[16px] text-bw08 font-metricR',
    EDIT_ICON: 'w-[18px] hover:cursor-pointer',
    TRANSFER_ICON: 'w-[20px] mr-[8px]',
    QUESTION_ICON: 'w-[20px] h-[20px] hover:cursor-pointer',
    TOOL_TIP_CONTAINER:
      'absolute translate-x-[82%] translate-y-[-90%] top-0 right-0 flex flex-col justify-center mt-[-15px]',
    TOOL_TIP_CONTENT:
      'w-[209px] h-[69px] text-xxs w-full font-metricR text-bw07 rounded-md px-[6px] py-2 bg-bw00 border border-bw05',
    TOOL_TIP_TRIANGLE: 'mt-[-10px] ml-[20px] z-0',
    TOOL_TIP_TRIANGLE_CLASS: 'triangle-FFFFFF',
    TOOL_TIP_HEAD: 'font-metricR text-[14px] text-bw08',
    TOOL_TIP_DESC: 'font-metricR text-[12px] text-bw07 z-100 leading-[16px]',
    TRANSFER_FEE: 'ml-auto font-metricR text-bw07 text-[14px]',
  },
};
export const ERROR_DATA = {
  STYLES: {
    CONTAINER: 'flex flex-col w-[456px] h-[500px] rounded-[8px] bg-bw00 py-[40px] px-[40px]',
    ICON: 'w-[76px] mb-[30px]',
    MAIN_HEAD: 'font-metricR text-bw08 text-[20px] mb-[12px]',
    DESC: 'font-metricR text-[16px] text-bw07 max-w-[312px]',
    CTAS_WRAPPER: 'flex flex-col mt-auto',
    MAIN_CTA:
      'max-w-[100%] mt-auto text-sm text-bw00 bg-action03 hover:bg-action04 active:bg-action04 h-12 rounded font-metricRBold mb-[12px]',
    SEC_CTA: 'font-metricR text-[14px] text-bw06',
  },
};

export const ACH_OUT_ERRORS = {
  INSUFFICIENT_BALANCE_CODE_NAME: 'ACH_OUT_INSUFFICIENT_BALANCE',
  INSUFFICIENT_BALANCE_CODE: 4244,
  INVALID_ROUTING_NUMBER_CODE: 4536,
  BILL_ALREADY_PAID: 5067,
};

export const SupplierPickerRoute = `/${VIEWS_MAP.SUPPLIER.BASE}/${VIEWS_MAP.SUPPLIER.PICKER}`;
export const AddSupplierRoute = `/${VIEWS_MAP.SUPPLIER.BASE}/${VIEWS_MAP.SUPPLIER.MANAGE.BASE}`;
